import { render, staticRenderFns } from "./SGPPaginacaoComponent.vue?vue&type=template&id=07dc4e88&scoped=true"
import script from "./SGPPaginacaoComponent.vue?vue&type=script&lang=js"
export * from "./SGPPaginacaoComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPPaginacaoComponent.vue?vue&type=style&index=0&id=07dc4e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc4e88",
  null
  
)

export default component.exports